<div
  [ngClass]="
    'idp-price-container ' + size + ' idp-price-container--' + flexAlign
  "
>
  <span *ngIf="multiUnit && miles && miles.value && !displayMilesBelowCash">
    {{ miles.value }}
    <span class="idp-price-container__price--sup">{{ miles.code }}</span>
  </span>
  <span *ngIf="cash && cash.value">
    <span *ngIf="multiUnit && miles && miles.value && !displayMilesBelowCash">
      +&nbsp;
    </span>
    <span>
      <span
        [innerHtml]="cash.symbol + ' '"
        class="idp-price-container__price--sup"
      ></span>
      <span class="idp-price-container__price--value">{{ cash.value }}</span>
      <span class="idp-price-container__price--sup">{{ cash.fraction }}</span>
      <span *ngIf="cash.code" class="idp-price-container__price--sup">
        {{ ' ' + cash.code }}
      </span>
    </span>
  </span>
  <span *ngIf="multiUnit && miles && miles.value && displayMilesBelowCash">
    {{ miles.value }}
    <span class="idp-price-container__price--sup">{{ miles.code }}</span>
  </span>
</div>
